/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:router
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/21 | 富士通株式会社         | 新規作成
// 01.01.00 | 2022/06/27 | 富士通Japan株式会社    | 令和4年度改修対応（8月リリース）
// 01.02.00 | 2022/09/29 | 富士通Japan株式会社    | 令和4年度改修対応（2次リリース）
// 01.03.00 | 2023/04/20 | 富士通Japan株式会社    | 令和5年度改修対応（1次リリース）
// 01.04.00 | 2023/10/10 | 富士通Japan株式会社    | 令和5年度改修対応（1次リリース）
// 01.05.00 | 2023/10/31 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
 */
import { createRouter, createWebHashHistory } from 'vue-router'

// compornent
import BC001 from '@/views/BC001/BC001.vue'
import BC004 from '@/views/BC004/BC004.vue'
import SystemError from '@/views/common/SystemError.vue';
import BrowserError from '@/views/common/BrowserError.vue';
import NotFoundError from '@/views/common/NotFoundError.vue';

import BC002 from '@/views/BC002/BC002.vue'
import BC003 from '@/views/BC003/BC003.vue'
import BC005 from '@/views/BC005/BC005.vue'
import BC006 from '@/views/BC006/BC006.vue'
import BC007 from '@/views/BC007/BC007.vue'
import BC008 from '@/views/BC008/BC008P.vue'
import BC009 from '@/views/BC009/BC009P.vue'
import BC010 from '@/views/BC010/BC010.vue'
import BC011 from '@/views/BC011/BC011P.vue'
import BC012C1 from '@/views/BC012/BC012C1.vue'
import BC012C2 from '@/views/BC012/BC012C2.vue'  
import BC013C1 from '@/views/BC013/BC013C1.vue'
import BC013C2 from '@/views/BC013/BC013C2.vue'
import BC015 from '@/views/BC015/BC015.vue'
import BC016 from '@/views/BC016/BC016.vue'
import BC017 from '@/views/BC017/BC017.vue'
import BC018 from '@/views/BC018/BC018.vue'
import BC019 from '@/views/BC019/BC019.vue'
import BC020 from '@/views/BC020/BC020.vue'
import BC021 from '@/views/BC021/BC021.vue'
import BC050 from '@/views/BC050/BC050.vue'
import BC051 from '@/views/BC051/BC051.vue'
import BC052 from '@/views/BC052/BC052.vue'
import BC053 from '@/views/BC053/BC053.vue'
import BC055 from '@/views/BC055/BC055.vue'
import BC056 from '@/views/BC056/BC056.vue'
import BC057 from '@/views/BC057/BC057.vue'
import BC058 from '@/views/BC058/BC058P.vue'
import BC059 from '@/views/BC059/BC059P.vue'
import BC060 from '@/views/BC060/BC060.vue'
import BC061 from '@/views/BC061/BC061P.vue'
import BC090 from '@/views/BC090/BC090.vue'

// store
import store from '@/store/store.js'
import { STORE_USER_GET_INFO, STORE_VIEW_NAME, STORE_VIEW_TITLE, STORE_ERROR_CLEAR,
			STORE_VIEW_IS_BROWSER_BACK, STORE_VIEW_BROWSER_BACK, STORE_DIALOG_IS_DIALOG_FLG } from '@/const/store.js';
import { VIEWS, PATH_SYSTEMERROR } from '@/const/route.js';
import { DIALOG_BUTTON_LIST_KEY } from '@/const/const.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_errorDialog } from '@/common/dialogUtility.js';

const routes = [{
		path: '/',
		name: 'TOP'
	},
	// ログイン
	{
		path: '/BC001',
		name: 'BC001',
		component: BC001,
		props: true,
		meta: { isPublic: true } // 認証不要
	},
	// メニュー画面
	{
		path: '/BC002',
		name: 'BC002',
		component: BC002
	},
	// 利用者仮登録
	{
		path: '/BC003',
		name: 'BC003',
		component: BC003,
		props: true,
		meta: { isPublic: true } // 認証不要
	},
	// 利用者本登録
	{
		path: '/BC004',
		name: 'BC004',
		component: BC004,
		meta: { isPublic: true } // 認証不要
	},
	// 募集住宅検索
	{
		path: '/BC005',
		name: 'BC005',
		component: BC005,
		meta: { isPublic: true } // 認証不要
	},
	// 募集住宅一覧
	{
		path: '/BC006',
		name: 'BC006',
		component: BC006,
		props: true,
		meta: { isPublic: true } // 認証不要
	},
	// 募集住宅情報
	{
		path: '/BC007',
		name: 'BC007',
		component: BC007,
		props: true,
		meta: { isPublic: true } // 認証不要
	},
	// 世帯情報入力
	{
		path: '/BC008',
		name: 'BC008',
		component: BC008,
		props: true
	},
	// 申込み内容の確認
	{
		path: '/BC009',
		name: 'BC009',
		component: BC009,
		props: true
	},
	// 申込み履歴一覧
	{
		path: '/BC010',
		name: 'BC010',
		component: BC010,
		props: true,
		// meta: { isPublic: true } // 認証不要
	},
	// 申込み内容確認
	{
		path: '/BC011',
		name: 'BC011',
		component: BC011,
		props: true
	},
	// 募集情報CSV取込み
	{
		path: '/BC012C1',
		name: 'BC012C1',
		component: BC012C1,
		props: true
	},
	{
		path: '/BC012C2',
		name: 'BC012C2',
		component: BC012C2,
		props: true
	},
	// 住宅状況情報CSV取込み
	{
		path: '/BC013C1',
		name: 'BC013C1',
		component: BC013C1,
		props: true
	},
	{
		path: '/BC013C2',
		name: 'BC013C2',
		component: BC013C2,
		props: true
	},
	// 利用者情報検索・一覧
	{
		path: '/BC015',
		name: 'BC015',
		component: BC015,
		props: true
	},
	// 利用者情報
	{
		path: '/BC016',
		name: 'BC016',
		component: BC016,
		props: true
	},
	// 利用者情報確認・変更
	{
		path: '/BC017',
		name: 'BC017',
		component: BC017,
		props: true,
	},
	// 住宅状況入力
	{
		path: '/BC018',
		name: 'BC018',
		component: BC018,
		props: true,
	},
	// 住宅状況入力の確認
	{
		path: '/BC019',
		name: 'BC019',
		component: BC019,
		props: true,
	},
	// 利用者情報削除
	{
		path: '/BC020',
		name: 'BC020',
		component: BC020,
		props: true
	},
	// 利用者情報仮変更内容確認画面
	{
		path: '/BC021',
		name: 'BC021',
		component: BC021,
		meta: { isPublic: true } // 認証不要
	},
	// 住宅情報（随時募集・管理者用）
	{
		path: '/BC050',
		name: 'BC050',
		component: BC050,
		props: true,
	},
	// 住宅一覧(随時募集・管理者用)
	{
		path: '/BC051',
		name: 'BC051',
		component: BC051,
		props: true,
	},
	// 住宅情報変更入力（随時募集・管理者用）
	{
		path: '/BC052',
		name: 'BC052',
		component: BC052,
		props: true

	},
	// 住宅情報変更内容確認（随時募集・管理者用）
	{
		path: '/BC053',
		name: 'BC053',
		component: BC053,
		props: true
	},
	// 募集住宅検索（随時募集・管理者用【代理申込み】）
	{
		path: '/BC055',
		name: 'BC055',
		component: BC055
	},
	// 募集住宅一覧（随時募集・管理者用【代理申込み】）
	{
		path: '/BC056',
		name: 'BC056',
		component: BC056,
		props: true
	},
	// 募集住宅情報（随時募集・管理者用【代理申込み】）
	{
		path: '/BC057',
		name: 'BC057',
		component: BC057,
		props: true
	},
	// 世帯情報入力（随時募集・管理者用【代理申込み】）
	{
		path: '/BC058',
		name: 'BC058',
		component: BC058,
		props: true
	},
	// 世帯情報入力の確認（随時募集・管理者用【代理申込み】）
	{
		path: '/BC059',
		name: 'BC059',
		component: BC059,
		props: true
	},
	// 申込み履歴検索・一覧（管理者用）
	{
		path: '/BC060',
		name: 'BC060',
		component: BC060,
		props: true
	},
	// 申込者情報詳細（管理者用）
	{
		path: '/BC061',
		name: 'BC061',
		component: BC061,
		props: true
	},
	// 稼働日付設定（管理者用）
	{
		path: '/BC090',
		name: 'BC090',
		component: BC090,
	},
	// システムエラー
	{
		path: PATH_SYSTEMERROR,
		name: 'SYSTEMERROR',
		component: SystemError,
		props: true,
		meta: { isPublic: true } // 認証不要
	},
	// ブラウザエラー
	{
		path: '/BrowserError',
		name: 'BrowserError',
		component: BrowserError,
		meta: { isPublic: true } // 認証不要
	},
	// 404エラー
	{
		path: '/:catchAll(.*)',
		name: 'NotFoundError',
		component: NotFoundError,
		meta: { isPublic: true } // 認証不要
	},

]

const scrollBehavior = (to, from, savedPosition) => {
	if (savedPosition) {
		return savedPosition
	} else {
		return { left: 0, top: 0 }
	}
}

const router = createRouter({
	history: createWebHashHistory(process.env.BASE_URL),
	routes,
	scrollBehavior
})

router.beforeEach((to, from, next) => {

	// リロード、外部サイトから移動してきた場合
	if (from.fullPath == "/") {
		store.commit(STORE_VIEW_BROWSER_BACK, false);
	}

	if (store.getters[STORE_VIEW_IS_BROWSER_BACK] ||
		(from.fullPath.indexOf('/BrowserError') > -1)) {
		// ブラウザのページバックが行われた場合
		let callBack = function(flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				return next(false);
			}
		}

		// // システムエラー画面でのリロード対応
		// if (from.fullPath == "/" && to.fullPath.indexOf(PATH_SYSTEMERROR) > -1) {
		// 	return next();
		// }

		// 既に他のダイアログを表示している場合はダイアログを出力せず画面遷移抑止する。
		if (store.getters[STORE_DIALOG_IS_DIALOG_FLG]) {
			return next(false);
		}

		co_errorDialog(co_getMessage('E0081'), callBack);
		return next(false);

	} else {

		let userInfo = store.getters[STORE_USER_GET_INFO];
		if (to.matched.some(record => !record.meta.isPublic) && !userInfo.userToken) {
			// 認証が必要な場合かつ、ログインしていない場合
			next({ path: '/BC001', query: { redirect: to.fullPath } });
		} else {
			next();
		}
	}

});

// 画面遷移確定後処理
router.afterEach(function(to /*, from*/ ) {

	// url に対応する画面名を取得
	let title = '都営住宅入居者募集サイト';
	for (let i = 0; i < VIEWS.length; i++) {
		if (VIEWS[i].name == to.name) {
			title = VIEWS[i].title;
			break;
		}
	}

	// ブラウザバックによる遷移でない場合
	if (store.getters[STORE_VIEW_IS_BROWSER_BACK] == false) {

		// 初期化
		// 画面ID
		store.commit(STORE_VIEW_NAME, to.name);
	}

	// 遷移先がシステムエラー画面以外の場合のみ
	if (store.getters[STORE_VIEW_IS_BROWSER_BACK] == false
		&& to.path != PATH_SYSTEMERROR) {
		// 画面名
		store.commit(STORE_VIEW_TITLE, title);

		// エラークリア
		store.commit(STORE_ERROR_CLEAR);
	}

})

export default router